import { render, staticRenderFns } from "./beneficiaries.page.vue?vue&type=template&id=a0b8e274&"
import script from "./beneficiaries.page.vue?vue&type=script&lang=ts&"
export * from "./beneficiaries.page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports